import lazyLoading from "./lazyLoading";
import CommonLayout from "../components/Layouts/Common";
import CustomerGuard from "./guards/customer-guard";

export default [
    {
        path: "/customers",
        component: CommonLayout,
        beforeEnter: CustomerGuard,
        children: [
            {
                name: "customer.dashboard",
                path: "dashboard",
                component: lazyLoading("Dashboard/Index"),
                meta: {
                    module: "dashboard",
                },
            },
            {
                name: "customer.profile",
                path: "profile",
                component: lazyLoading("Customers/Profile/Index"),
                meta: {
                    module: "dashboard",
                },
            },
            {
                name: "customer.appointments",
                path: "appointments",
                component: lazyLoading("Customers/Appointment/Index"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.appointments.show",
                path: "appointments/:id",
                component: lazyLoading("Customers/Appointment/Show"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.issues.show",
                path: "issues/:id",
                component: lazyLoading("Issues/Show"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "customer.exams",
                path: "exams",
                component: lazyLoading("Customers/Exams/Index"),
                meta: {
                    module: "exams",
                },
            },
            {
                name: "customer.schedules",
                path: "schedule",
                component: lazyLoading("Issues/Schedule/Form"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.new_issue",
                path: "issue_appointments/:id?",
                component: lazyLoading("Issues/Schedule/Form"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.confirm-schedule",
                path: "confirm-schedule",
                component: lazyLoading("Issues/Schedule/Confirm"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.vaccines",
                path: "vaccines",
                component: lazyLoading("Customers/Vaccines/Index"),
                meta: {
                    module: "vaccines",
                },
            },
            {
                name: "customer.conversations",
                path: "conversations",
                component: lazyLoading("Conversations/Index"),
                meta: {
                    module: "chats",
                },
            },
        ],
        pet: [
            {
                name: "customer.dashboard",
                path: "dashboard",
                component: lazyLoading("Dashboard/Index"),
                meta: {
                    module: "dashboard",
                },
            },
            {
                name: "customer.profile",
                path: "profile",
                component: lazyLoading("Customers/Profile/Index"),
                meta: {
                    module: "dashboard",
                },
            },
            {
                name: "customer.appointments",
                path: "appointments",
                component: lazyLoading("Customers/Appointment/Index"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.appointments.show",
                path: "appointments/:id",
                component: lazyLoading("Customers/Appointment/Show"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.exams",
                path: "exams",
                component: lazyLoading("Customers/Exams/Index"),
                meta: {
                    module: "exams",
                },
            },
            {
                name: "customer.schedules",
                path: "schedule",
                component: lazyLoading("Issues/Schedule/Form"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.confirm-schedule",
                path: "confirm-schedule",
                component: lazyLoading("Issues/Schedule/Confirm"),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "customer.vaccines",
                path: "vaccines",
                component: lazyLoading("Customers/Vaccines/Index"),
                meta: {
                    module: "vaccines",
                },
            },
            {
                name: "customer.conversations",
                path: "conversations",
                component: lazyLoading("Conversations/Index"),
                meta: {
                    module: "chats",
                },
            },
        ],
    },
];
